import Vue from 'vue'
import router from './router'
import Router from 'vue-router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './element-variables.scss'
import App from './App.vue'
import http from './utils/http'
import util from './utils/util'
import './assets/fonts/fonts.css'
import VueWechatTitle from 'vue-wechat-title'
import toast from './utils/toast'
import echarts from 'echarts'
import BaiduMap from 'vue-baidu-map'
import './permission' // permission control
import server from './server'
import plugins from './components/common/index'
import md5 from 'md5';
Vue.prototype.$md5 = md5;
Vue.use(plugins)


import vueJsonp from 'vue-jsonp'
Vue.use(vueJsonp)

Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$util = util
Vue.prototype.$axios = axios
Vue.prototype.$toast = toast
Vue.prototype.$echarts = echarts
// 把接口都添加到$server对象中 省去每次调用接口都需要import到页面
Vue.prototype.$server = server
Vue.use(VueWechatTitle)
Vue.use(ElementUI)


Vue.use(BaiduMap, {
	// ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
	ak: 'YOUR_APP_KEY'
})
const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

	// 设置拦截器
	
	axios.interceptors.request.use(
	
	config => {
	if (config.method === 'post') {
	config.data = qs.stringify(config.data);
	
	}
	
	return config;
	
	},
	
	error =>{
	return Promise.reject(error);
	
	}
	
	);

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
